export default __webpack_public_path__ + "static/empty-6a8cfdcf72b6b013815829333837f8bd.svg";